import { createReducer } from 'redux-act';
import { setIpAddress, setBrowser, setDeviceFingerprint, setDeviceFingerprintFailure, setIsBot } from './userEnvironmentActions';

const initialState = {
  ipAddress: null,
  deviceFingerprint: null,
  browser: {
    name: null,
    version: null,
    type: null,
    userAgent: null,
  },
  isBot: null,
};

export const reducer = createReducer(
  {
    [setIpAddress]: (state, ipAddress) => ({ ...state, ipAddress }),
    [setBrowser]: (state, browser) => ({ ...state, browser }),
    [setIsBot]: (state, isBot) => ({ ...state, isBot }),
    [setDeviceFingerprint]: (state, deviceFingerprint) => ({ ...state, deviceFingerprint }),
    [setDeviceFingerprintFailure]: (state, deviceFingerprintError) => ({ ...state, deviceFingerprintError }),
  },
  initialState,
);
